import { render } from "./EmployeeShow.vue?vue&type=template&id=1317470a&scoped=true"
import script from "./EmployeeShow.vue?vue&type=script&lang=js"
export * from "./EmployeeShow.vue?vue&type=script&lang=js"

import "./EmployeeShow.vue?vue&type=style&index=0&id=1317470a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1317470a"]])

export default __exports__